require('angular');
require('angular-animate');
require('@uirouter/angularjs');
require('gsap/TweenMax');
require('./angular-gsapify-router');
module.exports = 'hj.gsapifyRouter';
